import { Howl, Howler } from 'howler';

export class AudioPlayer {
	private static instance: AudioPlayer;

	public rain = new Howl({
		src: '../static/audio/rain.mp3',
		loop: true,
	});
	// public waterSplash = new Howl({
	// 	src: '../static/audio/water-splash.mp3',
	// });
	public iceSwoosh = new Howl({
		src: '../static/audio/ice-swoosh.mp3',
	});
	public bubblePop = new Howl({
		src: '../static/audio/bubble-pop.mp3',
	});

	public static getInstance(): AudioPlayer {
		if (!AudioPlayer.instance) {
			AudioPlayer.instance = new AudioPlayer();
		}

		return AudioPlayer.instance;
	}
}
